import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { TransfiyaResponse } from '../models/transfiya-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class TransfiyaService {
  transfiyaConsultUrl = `${environment.urlglobal_api}/integrations/transfiya/consult`;

  constructor(private http: HttpClient) { }

  transfiyaConsult(token: string, transactionId: string) {
    const headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    const request = { token: token, transfer_id: transactionId };

    return this.http.post<TransfiyaResponse>(this.transfiyaConsultUrl, request, headers).pipe(map((res: TransfiyaResponse) => res));
  }
}
